import { useCallback } from 'react';
import { IHandleSetInputParams } from '../types';
import { THandleDelInput } from './types';
import { isArray, isFunction, isRegExp, omit, reduce } from 'lodash';

export const useHandleDelInput = ({
  inputs,
  setInputs,
}: IHandleSetInputParams): THandleDelInput => {
  return useCallback(
    (criteria: string | string[] | RegExp | Function) => {
      var newInputs = {};
      if (isRegExp(criteria)) {
        newInputs = reduce(
          inputs,
          (r, v, k) => {
            if (criteria.test(k)) return { ...r };
            return { ...r, [k]: v };
          },
          {}
        );
      } else if (isFunction(criteria)) {
        newInputs = reduce(
          inputs,
          (r, v, k) => {
            if (criteria(v)) return { ...r };
            return { ...r, [k]: v };
          },
          {}
        );
      } else if (isArray(criteria)) {
        newInputs = omit(inputs, criteria);
      } else {
        newInputs = omit(inputs, criteria as string);
      }
      setInputs(newInputs);
    },
    [inputs, setInputs]
  );
};
